module.exports = __webpack_public_path__ + "static/img/swhz_qr.02f9c091.png";